import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(1) * 2,
    minWidth: 0, // So the Typography noWrap works,
    display: "flex",
    flexDirection: "column",
    overflow: 'auto'
  },
  toolbar: theme.mixins.toolbar,
});

const DrawerMainContent = (props) => {
  const { classes, children, padding } = props;
  const toolbar = padding ? <div className={classes.toolbar} /> : null;
  return (
    <main className={classes.content}>
      {toolbar}
      {children}
    </main>
  );
};

DrawerMainContent.defaultProps = {
  padding: true,
};

DrawerMainContent.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
  padding: PropTypes.bool,
};

export default withStyles(styles)(DrawerMainContent);
